export class LoadClientPrefixEntity{

    id:number;
    prefix:string;
    creationDate:string;
    active:boolean;
    parametrizationId:number;
    userId:number;
    constructor (){}
}